import { render, staticRenderFns } from "./UGSMultipleSessionConfig.vue?vue&type=template&id=71488f56&scoped=true&"
import script from "./UGSMultipleSessionConfig.vue?vue&type=script&lang=js&"
export * from "./UGSMultipleSessionConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71488f56",
  null
  
)

export default component.exports